import { getEditLocation } from "../../../core/util/functions";

export const otherSettingsLocation = "/settings/other"


